import EventMarketRemoveMapper from './event-market-remove-mapper';

const EventMarketRemoveModel = {
    mapper: EventMarketRemoveMapper,

    categoryId: {
        fieldName: 'c',
        type: String,
    },

    eventId: {
        fieldName: 'e',
        type: String,
    },

    eventMbn: {
        fieldName: 'b',
        type: Number,
    },

    leagueId: {
        fieldName: 'g',
        type: String,
    },

    live: {
        fieldName: 'l',
        type: Boolean,
    },

    marketCount: {
        fieldName: 'k',
        type: Number,
    },

    marketIds: {
        fieldName: 'm',
        type: Array,
    },

    scheduleDate: {
        fieldName: 'd',
        type: Number,
    },

    sportId: {
        fieldName: 's',
        type: String,
    },

    type: {
        fieldName: 't',
        type: String,
    },

    outright: {
        fieldName: 'o',
        type: Boolean,
    },
};

export default EventMarketRemoveModel;
